// extracted by mini-css-extract-plugin
module.exports = {"email":"emailBtn__email__3PvrX","iconEmail":"emailBtn__iconEmail__2yRIR"};